// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"IconButton_removeButton__dRtvO","red":"IconButton_red__gMow8","blue":"IconButton_blue__RXsNl"};